module.exports = __webpack_public_path__ + "static/media/successful-booking-icon.9242dbd5.svg";